
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/india/blog",
      function () {
        return require("private-next-pages/india/blog.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/india/blog"])
      });
    }
  